import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type WishlistTag, wishlistTag } from "../schemas/wishlistTag";

export const addWishlistTagProps = z
  .object({
    token: z.string(),
    name: z.string(),
  })
  .extend(requestConfig.shape);

export type AddWishlistTagProps = z.infer<typeof addWishlistTagProps>;

export const addWishlistTag = async (
  args: AddWishlistTagProps,
): Promise<WishlistTag> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    name,
    proxyAuthSecret,
  } = parseServiceInput(addWishlistTagProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v3/wishlist/tag`, {
    method: "POST",
    headers,
    body: JSON.stringify({ name }),
  });

  return parseServiceOutput(response, wishlistTag, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
